import React from 'react'
import Screen from 'containers/Screen'
import BlackFridayBox from 'components/BlackFriday'

export default function BlackFriday () {
  return (
    <Screen title={''}>
      <BlackFridayBox />
    </Screen>
  )
}
